import { inject, injectable } from 'inversify';
import {
  CategoriesByStoreRequest,
  CategoriesResponse,
  CategoriesServiceInterface,
} from './CategoriesService.types';

import HttpClient from 'src/features/http';
import { backendUrl } from 'src/config';

@injectable()
class CategoriesService implements CategoriesServiceInterface {
  @inject(HttpClient) private client!: HttpClient;

  async getAll() {
    return await this.client
      .getClient()
      .get<CategoriesResponse>('/stock/categories/', { baseURL: backendUrl });
  }

  async getByStoreSlug({ storeSlug }: CategoriesByStoreRequest) {
    return await this.client
      .getClient()
      .get<CategoriesResponse>(`/stock/${storeSlug}/categories/`, {
        baseURL: backendUrl,
        params: { ordering: 'order' },
      });
  }
}

export default CategoriesService;
